"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var task_1 = require("@alife/task");
var next_1 = require("@alifd/next");
var config_1 = require("../config");
var Cookie = require("js-cookie");
var deviceManage_1 = require("./deviceManage");
var contextManage_1 = require("../contextManage");
var react_1 = require("react");
var FormItem = next_1.Form.Item;
var isLegal = function () {
    return Cookie.get("clientUserType") === "legal";
};
var formItemLayout = {
    labelCol: {
        fixedSpan: 6,
    },
    wrapperCol: {
        span: 14,
    },
};
var Verify = function (props) {
    /**
     * 确认用户
     */
    var confirmUser = function () {
        props.changeStatus(config_1.TASKTYPE.doubleConfirm);
    };
    /**
     * 法人登录
     */
    var doLegalAuth = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, cardNumber, param, res, _b, _c, data, _d, success, _e, errorMsg, extData, noAccount, _f, infoList, list, error_1;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    _a = props.cardNumber, cardNumber = _a === void 0 ? "" : _a;
                    param = {
                        identifier: cardNumber,
                        loginType: "offline",
                        credential: {
                            seq: "prelogin",
                        },
                    };
                    return [4 /*yield*/, task_1.Util.post("/newHall/uc/login/prepare", param)];
                case 1:
                    res = _g.sent();
                    _b = res || {}, _c = _b.data, data = _c === void 0 ? {} : _c, _d = _b.success, success = _d === void 0 ? false : _d, _e = _b.errorMsg, errorMsg = _e === void 0 ? "" : _e;
                    if (!success) {
                        next_1.Message.error(errorMsg);
                        return [2 /*return*/];
                    }
                    extData = data.extData;
                    noAccount = extData.noAccount, _f = extData.infoList, infoList = _f === void 0 ? [] : _f;
                    if (noAccount) {
                        // 新账户注册
                        props.changeStatus(config_1.TASKTYPE.register);
                    }
                    else {
                        // 确认身份信息
                        confirmUser();
                        list = infoList.map(function (item) { return ({
                            label: item.companyName,
                            value: item.userId,
                            bizKey: item.bizKey,
                        }); });
                        props.getCompanys(list);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _g.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 个人登录
     */
    var doPersonalAuth = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // 确认身份信息
            confirmUser();
            return [2 /*return*/];
        });
    }); };
    var manualAuth = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!task_1.Util.checkAccount(props)) {
                return [2 /*return*/];
            }
            if (isLegal()) {
                doLegalAuth();
            }
            else {
                doPersonalAuth();
            }
            return [2 /*return*/];
        });
    }); };
    var connectPad = function () {
        // 我这里只兼容了icestrack
        deviceManage_1.showPadManage();
    };
    var faceAuth = function () {
        var cardName = props.cardName, cardNumber = props.cardNumber;
        props.setCardName(cardName);
        props.setCardNumber(cardNumber);
        props.changeStatus(config_1.TASKTYPE.faceScanAuth);
    };
    var PersonalAuthCom = function () {
        return (React.createElement("span", { className: "btnContent", onClick: manualAuth }, "\u4EBA\u5DE5\u8BA4\u8BC1"));
    };
    return (React.createElement("div", null, isLegal() ? (React.createElement("div", { className: "bottomContent" },
        React.createElement(PersonalAuthCom, null))) : props.showFaceAuth ? (React.createElement("div", { className: "bottomContent" },
        React.createElement("span", { className: "btnContent", onClick: faceAuth }, "\u4EBA\u8138\u8BC6\u522B\u8BA4\u8BC1"),
        "\u65E0\u6CD5\u4F7F\u7528\u4EBA\u8138\uFF1F",
        React.createElement("span", { className: "btnLink", onClick: manualAuth }, "\u53EF\u4EBA\u5DE5\u8BA4\u8BC1"))) : (React.createElement("div", { className: "bottomContent" },
        React.createElement(PersonalAuthCom, null),
        "ipad\u672A\u8FDE\u63A5\uFF1F",
        React.createElement("span", { className: "btnLink", onClick: connectPad }, "\u53EF\u7ACB\u5373\u8FDE\u63A5")))));
};
var Login = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    var isPadConnect = function () {
        return Cookie.get("binded") === "1";
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "status" }, "\u8BF7\u8F93\u5165\u529E\u4E8B\u4EBA\u8EAB\u4EFD\u4FE1\u606F1"),
        React.createElement(next_1.Form, __assign({}, formItemLayout),
            React.createElement(FormItem, { label: "\u59D3\u540D", required: true, requiredMessage: "\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "username", placeholder: "\u771F\u5B9E\u59D3\u540D", size: "large", value: context.cardName, onChange: function (val) { context.setCardName(val); } })),
            React.createElement(FormItem, { label: "\u8BC1\u4EF6\u7C7B\u578B", required: true },
                React.createElement(next_1.Select, { dataSource: props.selectOpts, style: { width: "100%" }, onChange: function (value) { props.setActiveOtion(value); }, value: props.activeOption })),
            React.createElement(FormItem, { label: "\u8BC1\u4EF6\u53F7", required: true, requiredMessage: "\u8BC1\u4EF6\u53F7\u7801\u4E0D\u80FD\u4E3A\u7A7A" },
                React.createElement(next_1.Input, { className: "input", name: "idCard", value: context.cardNumber, onChange: function (value) { context.setCardNumber(value); }, placeholder: "\u8BC1\u4EF6\u53F7\u7801", size: "large" }))),
        React.createElement(Verify, { cardNumber: context.cardNumber, cardName: context.cardName, showFaceAuth: isPadConnect(), setCardNumber: context.setCardNumber, setCardName: context.setCardName, getCompanys: props.setCompanys, changeStatus: context.setStatus })));
};
exports.default = Login;
